export default "__VITE_ASSET__D$fWdx4b__"